import { useQuery, useQueryClient } from 'react-query'

import { Repository } from '@/services/repository'

export const useGetCallProducts = (callId?: string | number) => {
  const queryClient = useQueryClient()

  const query = useQuery(
    ['useGetCallProducts', { callId: Number(callId) }],
    async () => {
      if (callId) {
        const { callProducts, isEditable } =
          await Repository.Entity.CallProduct.Search({
            callId: Number(callId),
          })
        const call = await Repository.Entity.Call.FindById({
          callId: Number(callId),
        })

        return {
          callProducts,
          isEditable,
          equipmentId: call.Asset?.equipmentId,
        }
      }
    },
  )

  function invalidateCallProducts() {
    queryClient.invalidateQueries(['useGetCallProducts', { callId }])
  }

  return { query, invalidateCallProducts }
}
